export class CollectionCard {
    constructor(id, title, imageUrl) {
        this.id = id;
        this.title = title;
        this.imageUrl = imageUrl;
    }
}